import styled, { css } from "styled-components";

export const Content = styled.div`
    [class^="i-"] {
        color: ${p => p.theme.c.active};
        font-size: 28px;
        display: inline-block;
        overflow: hidden;
        margin-bottom: -8px;
    }

    .i-alert {
        font-size: 20px;
        margin-bottom: -4px;
        color: ${p => p.theme.c.info};
    }

    li [class^="i-"] {
        margin-left: -28px;
        margin-right: 0px;
        font-size: 20px;
        margin-bottom: -4px;
    }

    .list-style-none {
        list-style: none;
        [class^="i-"] {
            margin-left: -24px;
            margin-right: 4px;
        }
    }

    .tutorial-button {
        padding: 2px;
        display: inline-block;
        font-size: 14px;
        cursor: default;
        margin: 0 3px;

        &:hover {
            background-color: ${p => p.theme.c.active};
            color: ${p => p.theme.c.white};
        }
    }
`;

export const VideoFrame = styled.div`
    height: 342px;

    ${p =>
        p.theme.xs(css`
            height: 50vw;
        `)}
`;
